package com.milta.core.localization.translations.en

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Import a file",
    analysingTitle = "Analysing the file…",
    analysingSubtitle = "We're identifying the columns and detecting the deliveries in the spreadsheet.",
    fileSentSuffix = "just sent",
    structuredFormatBannerTitle = "Format recognized.",
    structuredFormatBannerMessage = "The columns were mapped automatically, no correction needed.",
    columnsInterpretedBannerTitle = "Columns interpreted automatically.",
    columnsInterpretedBannerMessage = "Check the flagged deliveries before adding them.",
    completePillLabel = "Everything is complete",
    invalidFileTitle = "File not supported.",
    invalidFileMessage = "Import a valid Excel (.xlsx) or CSV (.csv) file.",
    chooseAnotherFileButton = "Choose another file",
    extractionFailedTitle = "Unable to read this file.",
    extractionFailedMessage = "The spreadsheet seems empty or its structure wasn't recognized — check its content or enter the deliveries manually.",
    retryWithNewFileButton = "Try again with another file",
    serviceUnavailableTitle = "Analysis service temporarily unavailable.",
    serviceUnavailableMessage = "Try again in a moment, or complete this delivery manually in the meantime.",
)
